'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartTotalPriceDiscountsComponent = exports.cartTotalPriceDiscountsComponent = {
    template: require('./cart-total-price-discounts.html'),
    bindings: {
        close: '&',
        totalPriceDiscounts: '<'
    },
    controllerAs: 'vm',
    controller: ["discountTypeNames", function controller(discountTypeNames) {
        'ngInject';

        var vm = this;

        // vm.isTotalPriceDiscountId = isTotalPriceDiscountId;
        vm.getDiscountType = getDiscountType;
        vm.isActive = isActive;

        function getDiscountType(discountType) {
            return discountTypeNames[discountType].clientValue;
        }
        function isActive(discount) {

            return discount.isActive ? 'product-discount is-active' : 'product-discount';
        }
        // function isTotalPriceDiscountId(productDiscount) {
        //     return productDiscount.discountId === vm.totalPriceDiscountId ? 'product-discount is-active' : 'product-discount';
        // }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/components/cart-total-price-discounts.js
// module id = 907
// module chunks = 0